module.exports = __webpack_public_path__ + "bbfe4281fd6ff197d4d22b4f396aeb98.png";